<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6XmV84/tc-custom/9780814752821.jpg?1726574064562" alt="This image is the cover for the book T.D. Jakes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">T.D. Jakes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Examines the rise of one of the most prolific spiritual leader of modern times</b><br/><br/>T.D. Jakes has emerged as one of the most prolific spiritual leaders of our time. He is pastor of one of the largest churches in the country, CEO of a multimillion dollar empire, the host of a television program, author of a dozen bestsellers, and the producer of two Grammy Award-nominated CDs and three critically acclaimed plays. In 2001 <i>Time</i> magazine featured Jakes on the cover and asked: Is Jakes the next Billy Graham?<br/><br/><b>T.D. Jakes</b> draws on extensive research, including interviews with numerous friends and colleagues of Jakes, to examine both Jakes’s rise to prominence and proliferation of a faith industry bent on producing spiritual commodities for mass consumption. Lee frames Jakes and his success as a metaphor for changes in the Black Church and American Protestantism more broadly, looking at the ramifications of his rise—and the rise of similar preachers—for the way in which religion is practiced in this country, how social issues are confronted or ignored, and what is distinctly “American” about Jakes's emergence. While offering elements of biography, the work also seeks to shed light on important aspects of the contemporary American and African American religious experience.<br/><br/>Lee contends that Jakes’s widespread success symbolizes a religious realignment in which mainline churches nationwide are in decline, while innovative churches are experiencing phenomenal growth. He emphasizes the “American-ness” of Jakes’s story and reveals how preachers like Jakes are drawing followers by delivering therapeutic and transformative messages and providing spiritual commodities that are more in tune with postmodern sensibilities.<br/><br/>As the first work to critically examine Bishop Jakes’s life and message, <b>T.D. Jakes</b> is an important contribution to contemporary American religion as well as popular culture.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shayne Lee
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70a07aca